;(() => {
  if (window.__TOKI_CART_WATCHER__) return
  window.__TOKI_CART_WATCHER__ = true
  console.log("🟢 Optimized cart watcher initialized")

  const _fetch = window.fetch
  const _xhrOpen = XMLHttpRequest.prototype.open
  const _xhrSend = XMLHttpRequest.prototype.send

  function handleResponse(data) {

    const allItems = Array.isArray(data.items) ? data.items : []
    const removed = Array.isArray(data.items_removed) ? data.items_removed : []
    const added = Array.isArray(data.items_added) ? data.items_added : []

    const fullyRemoved = removed.filter(removedItem => {
      const stillExists = allItems.some(i => i.variant_id === removedItem.variant_id)
      return !stillExists
    })

    if (added.length) {
      window.tokiOnCartItemsAdded?.(added)
    }

    if (removed.length) {
      window.tokiOnCartItemsRemoved?.(removed)
    }

    if (fullyRemoved.length) {
      window.tokiOnCartItemsRemovedFull?.(fullyRemoved)
    }
  }

  // --- FETCH INTERCEPTOR ---
  window.fetch = async function (url, options) {
    const isCartChange =
      typeof url === "string" && url.includes("/cart/") && (url.includes("/change") || url.includes("/update") || url.includes("/add"))

    const response = await _fetch.apply(this, arguments)

    if (isCartChange) {
      try {
        const clone = response.clone()
        const data = await clone.json()
        handleResponse(data)

        if ( url.includes("/add") ) {
            window.tokiOnCartItemsAdded?.([data])
        }
      } catch {
        /* ignore non-JSON */
      }
    }

    return response
  }

  // --- XHR INTERCEPTOR ---
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._isCartRequest =
      typeof url === "string" && url.includes("/cart/") && (url.includes("/change") || url.includes("/update") || url.includes("/add"))
    return _xhrOpen.call(this, method, url, ...rest)
  }

  XMLHttpRequest.prototype.send = function (body) {
    if (this._isCartRequest) {
      this.addEventListener("load", function () {
        try {
          const data = JSON.parse(this.responseText)
          handleResponse(data)
            if ( url.includes("/add") ) {
            window.tokiOnCartItemsAdded?.([data])
         }
        } catch {
          /* ignore */
        }
      })
    }
    return _xhrSend.call(this, body)
  }

  console.log("✅ Cart watcher hooked into /cart/change.js responses")

  async function refreshSections(sectionIds = []) {
    const url = window.location.href

    const html = await fetch(url)
      .then(res => res.text())
      .catch(() => null)

    if (!html) return console.warn("Fetch failed")

    const doc = new DOMParser().parseFromString(html, "text/html")

    sectionIds.forEach(id => {
      const newBlock = doc.querySelector(`#${id}`)
      const currentBlock = document.querySelector(`#${id}`)

      if (newBlock && currentBlock) {
        currentBlock.innerHTML = newBlock.innerHTML
        console.log(`Updated #${id}`)
      } else {
        console.warn(`Section #${id} not found`)
      }
    })
  }

  function getSectionsWithMembershipPricing() {
    const sections = document.querySelectorAll('[id^="shopify-section-"]')
    const result = []

    sections.forEach(section => {
      if (section.querySelector(".toki-card-product__membership-pricing")) {
        result.push(section.id)
      }
    })

    return result
  }

  window.tokiOnCartItemsAdded = async function () {
    const sectionsToRefresh = getSectionsWithMembershipPricing()
    if (sectionsToRefresh.length) {
      await refreshSections([...new Set(sectionsToRefresh)])
    }
  }

  window.tokiOnCartItemsRemoved = async function () {
    const sectionsToRefresh = getSectionsWithMembershipPricing()
    if (sectionsToRefresh.length) {
      await refreshSections([...new Set(sectionsToRefresh)])
    }
  }
})()
